import * as types from "../Action/type";

const initialState = {
    loading: false,
    newMessage: [],
    error: null,
    direct: false,
    token: null,
    notifCount: 0,
    cahtCount: 0,
    typingMsg: false
}

const ChatReducer = (state = initialState, action) => {
    switch (action.type) {

        case types.FETCH_NEW_MESSAGE:
            console.log("new MESSAGE", [action.payload, ...state.newMessage])
            return {
                ...state,
                newMessage: [action.payload, ...state.newMessage],
            };
        case types.DELETE_NEW_MESSAGE:
            return {
                ...state,
                newMessage: [],
            };
        case types.FETCH_USER_TYPING:
            return {
                ...state,
                typingMsg: action.payload,
            };
        case types.FETCH_TOKEN:
            console.log("new token", action.payload)
            return {
                ...state,
                token: action.payload,
            };
        case types.UPDATE_NOTIFICATION_COUNT:
            return {
                ...state,
                notifCount: action.payload.count
            };
        case types.UPDATE_MESSAGE_COUNT:
            return {
                ...state,
                cahtCount: action.payload.count
            };
        case types.CLEAR_MSG_COUNT:
            return {
                ...state,
                cahtCount: 0
            }
            case types.CLEAR_NOTIFICATION_COUNT:
                return{
                    ...state,
                    notifCount:0
                }
        default:
            return state;
    }

}

export default ChatReducer;